export default import.meta.ROLLDOWN_FILE_URL_NS4amJI5XMLopbo2BwYNHA